// We disable no-param-reassign because we need to mutate the object
/* eslint-disable no-param-reassign */
import { MenopauseSymptoms } from '../../types/onboarding/survey';
import { ListOptions, SurveyOptions } from '../../types/surveys';
import { areObjectsEqual } from './survey';

const getBooleanValue = (value: string | boolean | null): boolean => {
  return typeof value === 'boolean' ? value : Boolean(value);
};

export const getMenopauseSymptoms = (symptomsList: ListOptions[]): MenopauseSymptoms => {
  return symptomsList.reduce((acc: MenopauseSymptoms, curItem: ListOptions) => {
    acc[curItem.name] = getBooleanValue(curItem.value);
    return acc;
  }, {});
};

export const handleMenopauseSymptoms = (
  options: SurveyOptions,
  menopauseSymptoms: MenopauseSymptoms,
  setMenopauseSymptoms: (symptoms: MenopauseSymptoms) => void,
) => {
  const symptoms = getMenopauseSymptoms(options.oldCurrentPage.questions);
  const isEqualObjects = areObjectsEqual(menopauseSymptoms, symptoms);

  if (!isEqualObjects) {
    let isNone = false;

    options.oldCurrentPage.questions.forEach(item => {
      if (item.name === 'none' && item.value && !menopauseSymptoms?.none) {
        isNone = true;
      }
    });

    const newAnswers: MenopauseSymptoms = {};
    options.oldCurrentPage.questions.forEach(item => {
      if (isNone) {
        item.value = item.name !== 'none' ? false : item.value;
      } else {
        item.value = item.name === 'none' ? false : item.value;
      }
      newAnswers[item.name] = getBooleanValue(item.value);
    });
    setMenopauseSymptoms({ ...newAnswers, none: isNone });

    options.allowChanging = false;
  } else {
    options.allowChanging = true;
  }
};
